import { z } from 'zod';

/**
 * Shape returned by `GET /api/health`. Defined in `src/shared` so both the Worker
 * (producer) and the SPA (consumer) validate against a single source of truth
 * (ARCHITECTURE_PLAN §3).
 */
export const HealthResponseSchema = z.object({
  ok: z.boolean(),
  version: z.string(),
  commit: z.string(),
  /** Result of the D1 reachability probe. */
  db: z.enum(['ok', 'unreachable']),
  /** Server time (epoch ms) for clock-skew debugging. */
  time: z.number().int(),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;
